// import { initDefaultProps } from '../_util/props-util';
import { defineComponent } from 'vue';
import useConfigInject from '../_util/hooks/useConfigInject';
// import type { ExtractPropTypes } from 'vue';
// import { collapseConditionPanelProps } from './commonProps';
// export { collapseConditionPanelProps };
// export type CollapseConditionPanelProps = Partial<
//   ExtractPropTypes<ReturnType<typeof collapseConditionPanelProps>>
// >;
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdCollapseConditionPanel',
    inheritAttrs: false,
    // emits: ['itemClick'],
    props: ['value'],
    // props: initDefaultProps(collapseConditionPanelProps(), {}),
    setup(props, { slots, attrs }) {
        const { prefixCls } = useConfigInject('collapse-condition-panel', props);
        return () => {
            return (<div {...attrs} class={`${prefixCls.value}-item`}>
          {slots.default?.()}
        </div>);
        };
    },
});
